import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import NewsPage from "@/pages/news/page";
import ResourcesPage from "@/pages/resources/page";
import TopicsPage from "@/pages/topics/page";
import DetailPage from "@/pages/detail/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import SiteLayout from "@/components/feature/SiteLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsPage /> },
      { path: "news/:category", element: <NewsPage /> },
      { path: "resources", element: <ResourcesPage /> },
      { path: "resources/:type", element: <ResourcesPage /> },
      { path: "topics", element: <TopicsPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;